module.exports = __webpack_public_path__ + "img/member.1805ec1b.svg";